<template>
  <div class="box-tab">
    <div id="accordion">
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion" href="#details1">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES63UC3']['0'] }}
          </h3>
        </div>
        <div id="details1" class="panel-collapse collapse in tab-detail">
          <div class="panel-body">
            <div class="detail detail-responsive">

              <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES63UC3']['130'] }}</div>
                  <div class="detail-right ">
                      <div class="detail-text width-100" id="coddesc_codinput" name="coddesc_codinput">{{ detail.tab1.codinput }}  {{ detail.tab1.desc_codinput }}</div>
                  </div>
              </div>

              <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES63UC3']['100'] }}</div>
                  <div class="detail-right ">
                      <div class="detail-text width-100" id="coddesc_codempid" name="coddesc_codempid">{{ detail.tab1.codempid }}  {{ detail.tab1.desc_codempid }}</div>
                  </div>
              </div>

              <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES63UC3']['110'] }}</div>
                  <div class="detail-right ">
                      <div class="detail-text width-100" id="dtereq" name="dtereq">{{ setDateOutput(detail.tab1.dtereq) }}</div>
                  </div>
              </div>

              <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES63UC3']['20'] }}</div>
                  <div class="detail-right ">
                      <div class="detail-text width-100" id="desc_codleave" name="desc_codleave">{{ detail.tab1.desc_codleave }}</div>
                  </div>
              </div>

              <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES63UC3']['30'] }}</div>
                  <div class="detail-right ">
                      <div class="detail-text width-100" id="deslereq" name="deslereq">{{ detail.tab1.deslereq }}</div>
                  </div>
              </div>

              <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES63UC3']['40'] }} - {{ labels['HRES63UC3']['60'] }}</div>
                  <div class="detail-right ">
                      <div class="detail-text width-100" id="dteBtw" name="dteBtw">{{ setDateOutput(detail.tab1.dtestrt) }} - {{ setDateOutput(detail.tab1.dteend) }}</div>
                  </div>
              </div>

              <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES63UC3']['50'] }} - {{ labels['HRES63UC3']['70'] }}</div>
                  <div class="detail-right ">
                      <div class="detail-text width-100" id="timBtw" name="timBtw">{{ detail.tab1.timstrt }} - {{ detail.tab1.timend }}</div>
                  </div>
              </div>

              <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES63UC3']['120'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-100">
                        <a :href="baseURL + detail.tab1.filepath" target="_blank" @click.stop v-show="detail.tab1.filename !== '' && detail.tab1.filename !== ' '">
                          <i class="fa fa-paperclip"></i> {{ detail.tab1.filename }}
                        </a>
                      </div>
                  </div>
              </div>

            </div>

          </div>
        </div>
      </div>

      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion" href="#details2">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES63UC4']['0'] }}
          </h3>
        </div>
        <div id="details2" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
            <div class="detail detail-responsive">
              <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES63UC4']['20'] }}</div>
                  <div class="detail-right ">
                      <div class="detail-text width-100" id="coddesc_codempid" name="coddesc_codempid">{{ detail.tab2.codempid }}  {{ detail.tab2.desc_codempid }}</div>
                  </div>
              </div>

              <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES63UC4']['30'] }}</div>
                  <div class="detail-right ">
                      <div class="detail-text width-100" id="coddescTypleave" name="coddescTypleave">{{ detail.tab2.typleave }} - {{ detail.tab2.desc_typleave }}</div>
                  </div>
              </div>

              <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES63UC4']['40'] }}</div>
                  <div class="detail-right detail-radio">
                      <input type="radio" name="flgdlemx1" v-model="detail.tab2.flgdlemx" value="Y" disabled="disabled"> <span class="radio-text">{{ labels['HRES63UC4']['50'] }}</span>
                      <input type="radio" name="flgdlemx2" v-model="detail.tab2.flgdlemx" value="N" disabled="disabled"> <span class="radio-text">{{ labels['HRES63UC4']['60'] }}</span>
                  </div>
              </div>

              <div class="clearfix detail-row entitlement">
                  <div class="detail-left label-left">&nbsp;</div>
                  <div class="detail-right">
                      <div class="hres63u-tab2-entitlement hres63u-tab2-entitlement-header bg-color-skin border-color-skin">{{ labels['HRES63UC4']['70'] }}</div>
                      <div class="hres63u-tab2-entitlement hres63u-tab2-entitlement-header bg-color-skin border-color-skin">{{ labels['HRES63UC4']['80'] }}</div>
                      <div class="hres63u-tab2-entitlement hres63u-tab2-entitlement-header bg-color-skin border-color-skin">{{ labels['HRES63UC4']['90'] }}</div>
                  </div>
              </div>

              <div class="clearfix detail-row entitlement">
                  <div class="detail-left label-left">{{ labels['HRES63UC4']['100'] }}</div>
                  <div class="detail-right">
                      <div class="hres63u-tab2-entitlement">{{ detail.tab2.day1 }}</div>
                      <div class="hres63u-tab2-entitlement">{{ detail.tab2.hur1 }}</div>
                      <div class="hres63u-tab2-entitlement">{{ detail.tab2.min1 }}</div>
                  </div>
              </div>

              <div class="clearfix detail-row entitlement">
                  <div class="detail-left label-left">{{ labels['HRES63UC4']['110'] }}</div>
                  <div class="detail-right">
                      <div class="hres63u-tab2-entitlement">{{ detail.tab2.day2 }}</div>
                      <div class="hres63u-tab2-entitlement">{{ detail.tab2.hur2 }}</div>
                      <div class="hres63u-tab2-entitlement">{{ detail.tab2.min2 }}</div>
                  </div>
              </div>

              <div class="clearfix detail-row entitlement">
                  <div class="detail-left label-left">{{ labels['HRES63UC4']['120'] }}</div>
                  <div class="detail-right">
                      <div class="hres63u-tab2-entitlement">{{ detail.tab2.day3 }}</div>
                      <div class="hres63u-tab2-entitlement">{{ detail.tab2.hur3 }}</div>
                      <div class="hres63u-tab2-entitlement">{{ detail.tab2.min3 }}</div>
                  </div>
              </div>

              <div class="clearfix detail-row entitlement">
                  <div class="detail-left label-left">{{ labels['HRES63UC4']['130'] }}</div>
                  <div class="detail-right">
                      <div class="hres63u-tab2-entitlement">{{ detail.tab2.day4 }}</div>
                      <div class="hres63u-tab2-entitlement">{{ detail.tab2.hur4 }}</div>
                      <div class="hres63u-tab2-entitlement">{{ detail.tab2.min4 }}</div>
                  </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion" href="#details3">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES63UC5']['0'] }}
          </h3>
        </div>
        <div id="details3" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
            <div class="detail detail-responsive">

               <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES63UC5']['20'] }}</div>
                  <div class="detail-right ">
                      <div class="detail-text width-100" id="coddesc_codempid" name="coddesc_codempid">{{ detail.tab3.detail.codempid }}  {{ detail.tab3.detail.desc_codempid }}</div>
                  </div>
              </div>

              <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES63UC5']['30'] }}</div>
                  <div class="detail-right ">
                      <div class="detail-text width-100" id="dtecycBtw" name="dtecycBtw">{{ setDateOutput(detail.tab3.detail.dtecycst) }} - {{ setDateOutput(detail.tab3.detail.dtecycen) }}</div>
                  </div>
              </div>

              <br>
              <hrms-table :columns="tab3Table" :data="detail.tab3.table" />

            </div>
          </div>
        </div>
      </div>

      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion" href="#details4">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRMS55XC1']['0'] }}
          </h3>
        </div>
        <div id="details4" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
            <div class="detail detail-responsive">
              <hrms55x callFrom="hrms55x2" :dateWork="detail.tab1.dtestrt" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="box-footer">
        <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>
    </div>

  </div>
</template>

<script>
import env from 'src/../env.js'
import hrms55x from 'components/hrms55x/component'
import assetsUtils from 'assets/js/utils'

export default {
  name: 'hres63u-detail',
  data () {
    return {
      baseURL: window.localStorage.getItem(env.site + '_baseURL') + 'file_uploads/',
      xxx: this.detail.tab1.dtestrt
    }
  },
  props: [ 'labels', 'detail', 'toggle', 'tab3Table', 'data', 'nowLang', 'labelsButton' ],
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    }
  },
  components: {
    hrms55x
  }
}
</script>



// WEBPACK FOOTER //
// detail.vue?a8c734b0